var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSearchTagQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.64057 8.00059C3.64057 5.68099 5.52098 3.80059 7.84057 3.80059C10.1602 3.80059 12.0406 5.68099 12.0406 8.00059C12.0406 8.8982 11.759 9.73006 11.2793 10.4126L9.83575 9.1491C9.5864 8.93085 9.20733 8.95607 8.98909 9.20542C8.77084 9.45476 8.79605 9.83383 9.0454 10.0521L10.4562 11.2869C9.73861 11.8588 8.82951 12.2006 7.84057 12.2006C5.52098 12.2006 3.64057 10.3202 3.64057 8.00059ZM11.3705 12.0872C10.424 12.9056 9.19008 13.4006 7.84057 13.4006C4.85824 13.4006 2.44057 10.9829 2.44057 8.00059C2.44057 5.01825 4.85824 2.60059 7.84057 2.60059C10.8229 2.60059 13.2406 5.01825 13.2406 8.00059C13.2406 9.20099 12.8489 10.3099 12.1864 11.2065L12.8215 11.7624C13.0709 11.9807 13.0961 12.3598 12.8778 12.6091C12.6596 12.8585 12.2805 12.8837 12.0312 12.6654L11.3705 12.0872Z",
    fill: "#EB0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearchTagQuestion);
export default __webpack_public_path__ + "static/media/icon_search_tag_question.0210d2dd477f446b6112b4e3b8681ea5.svg";
export { ForwardRef as ReactComponent };